"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSubmissions = exports.CampaignBar = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _CampaignSubmission = require("components/CampaignSubmission");

var _decorators = require("decorators");

var _linkList = babelHelpers.interopRequireDefault(require("block/linkList"));

var _catalogLink = babelHelpers.interopRequireDefault(require("card/block/catalogLink"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp, _class3, _descriptor5, _temp2;

var CampaignBar = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CampaignBar, _Component);

  function CampaignBar() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CampaignBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CampaignBar)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "campaignOpen", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "buttonText", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "campaign", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "headerText", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CampaignBar, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "stack block campaign-info-bar"
      }, this.headerText && _react.default.createElement("h3", {
        className: "campaign-info-group"
      }, this.headerText), this.campaignOpen && _react.default.createElement("div", {
        className: "cta-button-wrap"
      }, _react.default.createElement("button", {
        className: "cta-button btn btn-primary",
        type: "button",
        onClick: this.showCampaign
      }, this.buttonText)));
    }
  }, {
    key: "showCampaign",
    value: function showCampaign(event) {
      event.preventDefault();
      new _CampaignSubmission.CampaignSubmissionModal(this.campaign).show();
    }
  }], [{
    key: "value",
    value: function value(item) {
      return item;
    }
  }]);
  return CampaignBar;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "campaignOpen", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "buttonText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "campaign", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headerText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showCampaign", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showCampaign"), _class.prototype)), _class);
exports.CampaignBar = CampaignBar;

var UserSubmissionsListBlock =
/*#__PURE__*/
function (_LinkListBlock) {
  babelHelpers.inherits(UserSubmissionsListBlock, _LinkListBlock);

  function UserSubmissionsListBlock() {
    babelHelpers.classCallCheck(this, UserSubmissionsListBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(UserSubmissionsListBlock).apply(this, arguments));
  }

  babelHelpers.createClass(UserSubmissionsListBlock, null, [{
    key: "classNameFor",
    value: function classNameFor(block, page) {
      return {
        className: 'stack'
      };
    }
  }, {
    key: "contentList",
    value: function contentList(block, page) {
      return block.contentList;
    }
  }, {
    key: "card",
    value: function card(record, page, block) {
      return _catalogLink.default.card({
        id: record.id,
        child_type: 'catalogLink',
        target: record.id,
        hasCustomTitle: 0,
        showCustomContent: 0
      });
    }
  }, {
    key: "value",
    value: function value(record, page, block) {
      return Object.assign(babelHelpers.get(babelHelpers.getPrototypeOf(UserSubmissionsListBlock), "value", this).call(this, record, page, block), {
        hideTitle: true
      });
    }
  }]);
  return UserSubmissionsListBlock;
}(_linkList.default);

var UserSubmissions = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(UserSubmissions, _Component2);

  function UserSubmissions() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, UserSubmissions);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(UserSubmissions)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "block", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(UserSubmissions, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(UserSubmissionsListBlock, this.block);
    }
  }], [{
    key: "value",
    value: function value(bar, page, object) {
      return {
        type: 'campaign/InfoBar',
        name: 'UserSubmissions',
        block: UserSubmissionsListBlock.value({
          id: 'userSubmissionsBlock',
          child_type: 'linkList',
          title: '',
          displayMode: 'card',
          asCarousel: true,
          backgroundImage_name: '',
          backgroundImagePortrait_name: '',
          titleColor: '',
          bannerHeight: 'auto',
          contentList: bar.content
        })
      };
    }
  }]);
  return UserSubmissions;
}(_react.Component), _temp2), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "block", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.UserSubmissions = UserSubmissions;